"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./LoadingIndicator.scss");
const LoadingIndicator = ({ size = 24, color = 'var(--base-600, var(--v-600, #333))', customClass = '', gap = 10 }) => {
    return (react_1.default.createElement("div", { className: `loading-indicator flex ${customClass}`, style: { height: size, gap: `${gap}px` } },
        react_1.default.createElement("span", { style: {
                width: size,
                height: size,
                backgroundColor: color
            } }),
        react_1.default.createElement("span", { style: {
                width: size,
                height: size,
                backgroundColor: color
            } }),
        react_1.default.createElement("span", { style: {
                width: size,
                height: size,
                backgroundColor: color
            } })));
};
exports.default = LoadingIndicator;
